<template>
  <div class="part-modal-wrapper">
    <div class="part-modal">
      <span class="mck close" @click.prevent="$emit('close')">F</span>
      <form>
        <h2 v-if="newPart">НОВА ЧАСТ</h2>
        <h2 v-else>РЕДАКТИРАЙ ЧАСТ</h2>
        <template v-if="!newPart">
          <h3 v-if="typeof selected === 'object'">
            Тук може да редактирате името или бюджета на частта. Редакцията ще
            се отрази и в старите отчети.
          </h3>
          <h3 v-else>
            Тук може да редактирате името на частта. Редакцията ще се отрази и в
            старите отчети.
          </h3>
          <h3>
            Добавянето на нови части или редактиране на
            дейности/материали/механизации в съществуващите части става в
            съответните панели
          </h3>
        </template>
        <h3 v-else>
          Създайте нова част, която е независима от
          дейности/материали/механизации, но ще може да бъде отчитана към тях.
        </h3>
        <!-- NAME -->
        <div class="row">
          <div class="row__input">
            <label for="groupModalName" class="input-label">
              Име на частта
            </label>
            <div class="input-wrapper" :class="{ invalid: !isNameValid }">
              <span class="mck">i</span>
              <input
                id="groupModalName"
                type="text"
                placeholder="Име на частта"
                v-model="name"
                @keyup="isNameValid = true"
                @keydown.enter.prevent
              />
            </div>
          </div>
          <div
            class="row__input"
            v-if="newPart || typeof selected === 'object'"
          >
            <label for="groupModalName" class="input-label">
              Бюджет
            </label>
            <div class="input-wrapper" :class="{ invalid: !isBudgetValid }">
              <span class="mck">i</span>
              <input
                id="groupModalName"
                type="number"
                placeholder="Бюджет"
                v-model="budget"
                @keyup="isBudgetValid = true"
                @keydown.enter.prevent
              />
            </div>
          </div>
        </div>
        <!-- <template v-if="filteredActivities.length">
          <label for="partsModalActivities" class="input-label" title="Добавянето на нови части или редактиране на дейности в съществуващите части става в панела за Дейности">Участващи дейности:</label>
          <div class="users-list" title="Добавянето на нови части или редактиране на дейности в съществуващите части става в панела за Дейности">
            <span class="mck">U</span>
            <p v-for="(a,i) in filteredActivities" :key="`act-${i}`">{{ a.name }}</p>
          </div>
        </template> -->
        <div class="part-modal-actions">
          <div class="btns">
            <button class="btn btn-close" @click.prevent="$emit('close')">
              <span class="mck">F</span>
              Отказ
            </button>
            <button
              class="btn btn-new"
              type="submit"
              value="Submit"
              @click.prevent="save()"
            >
              <span class="mck">B</span>
              Запис
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import log from "../mixins/log.js";
export default {
  mixins: [log],
  props: ["activities", "selected", "newPart"],
  data() {
    return {
      isNameValid: true,
      isBudgetValid: true,
      name: this.selected
        ? typeof this.selected === "object"
          ? this.selected.name
          : this.selected
        : "",
      budget: this.selected
        ? typeof this.selected === "object"
          ? this.selected.budget
          : 0
        : 0,
      group: {
        name: "",
        isActive: true,
      },
      users: [],
    };
  },
  computed: {
    filteredActivities() {
      return this.activities.filter((a) => {
        return a.part === this.selected;
      });
    },
  },
  methods: {
    save() {
      if (!this.name) return (this.isNameValid = false);
      if ((this.newPart || typeof this.selected === "object") && !this.budget)
        return (this.isBudgetValid = false);
      this.$emit(
        "save",
        this.newPart || typeof this.selected === "object"
          ? { name: this.name, budget: this.budget }
          : this.name
      );
    },
    closeModal(update) {
      this.$emit("close", update);
    },
    handleEvents(e) {
      if (e.code === "Enter") {
        this.save();
      } else if (e.code === "Escape") {
        this.closeModal(false);
      }
    },
  },
  mounted() {
    window.addEventListener("keydown", this.handleEvents);
  },
  destroyed() {
    window.removeEventListener("keydown", this.handleEvents);
  },
};
</script>

<style scoped>
.part-modal-wrapper {
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 2;
}
.part-modal {
  background-color: #fff;
  border-radius: 4px;
  /* border-top: 10px solid #6d2600; */
  display: flex;
  flex-direction: column;
  /* height: 60vh; */
  overflow: auto;
  padding: 15px 20px 0;
  position: relative;
  width: 800px;
  -webkit-box-shadow: 10px 10px 204px -19px rgba(0, 0, 0, 0.52);
  -moz-box-shadow: 10px 10px 204px -19px rgba(0, 0, 0, 0.52);
  box-shadow: 10px 10px 204px -19px rgba(0, 0, 0, 0.52);
}
.close {
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  padding: 6px;
  position: absolute;
  right: 14px;
  top: 9px;
  transition: all 0.3s;
}
.close:hover {
  background-color: rgba(0, 0, 0, 0.1);
}
.part-modal-actions {
  display: flex;
  justify-content: center;
  padding: 20px 0;
}
.row {
  display: flex;
  gap: 10px;
}
.row__input {
  width: 100%;
}
.input-wrapper .mck,
.users-list .mck {
  color: #005a9e;
}
.input-wrapper input {
  color: #005a9e;
  font-weight: 700;
}

.input-wrapper input::placeholder {
  font-weight: 400;
}
.input-wrapper input,
.users-list {
  background-color: #deecf9;
}
.invalid .mck {
  color: #d91313;
}
.invalid input {
  background-color: #f8dcdc;
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}
.input-label {
  font-size: 12px;
  font-weight: 400;
}
form > h2 {
  font-size: 13px;
  font-weight: 700;
  text-align: center;
}
form > h3 {
  font-size: 12px;
  font-weight: 400;
  font-style: italic;
  text-align: center;
  color: #005a9e;
}
/* Responsive */
@media screen and (max-width: 900px) {
  .part-modal {
    width: 90%;
  }
}
@media screen and (max-width: 500px) {
  .part-modal-actions {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .btns {
    justify-content: center;
  }
}
@media screen and (max-height: 550px) {
  .part-modal {
    height: 100%;
  }
}
</style>
